<template>
  <div class="section">
    <div class="content">
      <h1 class="title">{{ $t("privacy.dataprotection.Title") }}</h1>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.dataprotection.content')"
      >
        {{ text }}
      </p>
      <h2>{{ $t("privacy.contactus.Title") }}</h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.contactus.content')"
      >
        {{ text }}
      </p>
      <h2>{{ $t("privacy.cookies.Title") }}</h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.cookies.content')"
      >
        {{ text }}
      </p>
      <h2>{{ $t("privacy.webanalysis.Title") }}</h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.webanalysis.content')"
      >
        {{ text }}
      </p>
      <h2>{{ $t("privacy.yourrights.Title") }}</h2>
      <p
        class="content"
        v-for="(text, index) in $t('privacy.yourrights.content')"
      >
        {{ text }}
      </p>
      <Contact />
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Contact.vue";

export default {
  components: { Contact },
};
</script>
